import React, { useContext, useEffect } from 'react'
import classnames from 'classnames'

// Context
import { AppContext } from '../../../contexts'

// Hooks
import {
  useShouldShowFeedback,
  useTrackFeedbackClick,
} from '../../../hooks/clientEvents'

// Components
import { Text, Button, If, Unless } from '../..'
import { Thumb } from '../../Svg'

// Styles
import styles from './Feedback.module.scss'

const Feedback = () => {
  const renderFeedback = useShouldShowFeedback()
  const { execute: trackFeedbackEvent } = useTrackFeedbackClick()
  const { thumbDirection, setThumbDirection } = useContext(AppContext)

  useEffect(() => {
    setThumbDirection(null)
  }, [])

  useEffect(() => {
    if (thumbDirection) {
      trackFeedbackEvent()
    }
  }, [thumbDirection])

  return (
    <div className={styles.root}>
      <If condition={renderFeedback}>
        <hr />
        <Text
          transform='uppercase'
          weight='semibold'
          size='s'
          letterSpacing='large'
          element='span'
        >
          Your Opinion
        </Text>
        <br />
        <If condition={thumbDirection === null}>
          <Button
            regular
            onClick={() => setThumbDirection('down')}
            className={classnames(styles.thumbs, styles.down)}
            iconStart={Thumb}
          />

          <Button
            regular
            onClick={() => setThumbDirection('up')}
            className={styles.thumbs}
            iconStart={Thumb}
          />

          <Text size='m' color='white' element='span'>
            How useful was this?
          </Text>
        </If>
        <Unless condition={thumbDirection === null}>
          <Text size='m' color='white' element='span'>
            Submitted. Thank you for your feedback.
          </Text>
        </Unless>
      </If>
    </div>
  )
}

export default Feedback
